import { defaultHTTPRequests } from '../http-request-service';
import {sessionRemoveData} from "../session-storage-management/session-storage-management";

/**
 *  Costante con tutte le chiamate inerenti a questa folder ( AUTH )
 */
export const paths = {
    LOGIN: '/pml/login',
    LOGIN_SAML: '/pml/loginSaml',
    LOGOUT_SAML: '/samlAuth/logoutArmonia?idAPP=arm',
    GET_ALERTS_PUBLIC: '/pml/alerts/active/public'
}

/**
 *  Funzione per effettuare la login
 * @param {Object} params - Oggetto contenente username e password
 */

export const POST_LOGIN = (params) => {
    let _body = {};
    if (params)
        Object.keys(params).forEach((value) => {
            _body[value] = params[value];
        });
    sessionRemoveData("filters");
    return defaultHTTPRequests("POST", paths.LOGIN, null, _body);
}
/**
 *  Funzione per effettuare la login
 */

export const GET_LOGIN_SAML = (params) => {
    sessionRemoveData("filters");
    return defaultHTTPRequests("GET", paths.LOGIN_SAML, null, null);
}
/**
 *  Funzione per effettuare la logOUT
 */

export const GET_LOGOUT_SAML = (params) => {
    return defaultHTTPRequests("GET", paths.LOGOUT_SAML, null, null);
}

export const GET_ALERTS_PUBLIC = () => {
    return defaultHTTPRequests('GET', paths.GET_ALERTS_PUBLIC, null);
}